// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3bi4d","inner":"Footer_inner__FYFLi","nextIcon":"Footer_nextIcon__ljvq_","innerLeft":"Footer_innerLeft__2FbXv"};